export enum EnumStatusCotacao {
	FECHADA,
	PARCIAL,
	ABERTA
}